import React from 'react'
import type { Translation } from '../../i18n'
import { serif, warm900, warm700, warm500, cream, textMuted } from './tokens'

type Props = {
  l: Translation['landing']['cta']
  home: string
}

export const CtaSection: React.FC<Props> = ({ l, home }) => (
  <section className="px-10 md:px-20 py-32 text-center" style={{ background: cream }}>
    <p className="flex items-center justify-center gap-3 text-[0.75rem] font-medium tracking-[0.18em] uppercase mb-4" style={{ color: warm500 }}>
      {l.sectionLabel}
    </p>
    <h2
      className="text-[clamp(2.2rem,4vw,3.5rem)] font-light leading-[1.15] max-w-[600px] mx-auto mb-6"
      style={{ fontFamily: serif, color: warm900 }}
    >
      {l.title}<br />
      <em className="italic" style={{ color: warm500 }}>{l.titleEm}</em>
    </h2>
    <p className="text-[1rem] leading-[1.85] max-w-[480px] mx-auto mb-10" style={{ color: textMuted }}>
      {l.body}
    </p>
    <a
      href={`${home}#produtos`}
      className="inline-block text-[0.82rem] font-medium tracking-[0.1em] uppercase px-8 py-3.5 rounded-[2px] no-underline transition-colors hover:opacity-90"
      style={{ background: warm700, color: cream }}
    >
      {l.button}
    </a>
  </section>
)
